/* RVA: product-card sibling swatch click-to-switch.
   Clicking a .rva-card-swatches swatch swaps the whole product card (title, subtitle,
   price, reviews, images, and its own swatch row) to the selected sibling product, in
   place, without leaving the page. The sibling's card HTML is fetched from an alternate
   product template (?view=rva-card) and cached. Falls back to normal navigation if the
   fetch fails or JS is unavailable (the swatch is a real <a href>). Uses event delegation
   so it survives Section Rendering re-renders. */
(function () {
  var SWATCH_SELECTOR = '.rva-card-swatches .related-swatch';
  var cache = {};

  function fetchCard(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    var viewUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=rva-card';
    return fetch(viewUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('product-block');
        cache[url] = block ? block.outerHTML : null;
        return cache[url];
      });
  }

  document.addEventListener('click', function (evt) {
    var swatch = evt.target.closest ? evt.target.closest(SWATCH_SELECTOR) : null;
    if (!swatch) return;

    // Let modifier / non-primary clicks open the product normally (e.g. new tab).
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button !== 0) return;

    var url = swatch.getAttribute('href');
    var currentBlock = swatch.closest('product-block, .product-block');
    if (!url || !currentBlock) return;

    evt.preventDefault();

    // Already showing this product — nothing to do.
    if (swatch.classList.contains('related-swatch--active')) return;

    currentBlock.classList.add('rva-card-loading');

    // Capture the outgoing card's image aspect ratio + crop so the swapped-in card keeps
    // the exact same image container (the fetched template renders without the section's
    // collection context, so its computed ratio can differ for scanning shapes).
    var oldAr = currentBlock.querySelector('.img-ar');
    var arValue = oldAr ? oldAr.style.getPropertyValue('--aspect-ratio') : '';
    var arContain = oldAr ? oldAr.classList.contains('img-ar--contain') : false;

    fetchCard(url)
      .then(function (outerHTML) {
        if (!outerHTML) { window.location.href = url; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = outerHTML;
        var newBlock = tmp.firstElementChild;
        if (!newBlock) { window.location.href = url; return; }
        if (arValue) {
          newBlock.querySelectorAll('.img-ar').forEach(function (el) {
            el.style.setProperty('--aspect-ratio', arValue);
            el.classList.toggle('img-ar--contain', arContain);
            el.classList.toggle('img-ar--cover', !arContain);
          });
        }
        currentBlock.replaceWith(newBlock);
      })
      .catch(function () {
        window.location.href = url;
      });
  });
})();
